













import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { ContextsState } from '@/store';
import { download } from '@/core/helpers/utils';
import { showFileUploader } from '@/core/components/fileUploader';
import container from '@/container';
import {
    FetchServiceContract,
    CONTRACTS,
    WindowsServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';

@Component
export default class Devtools extends Vue {
    @Inject(CONTRACTS.WindowsService) private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService) private _fetchService?: FetchServiceContract;

    public terminateProcessing() {
        const contextId = ContextsState.currentContextId;
        container
            .get<FetchServiceContract>(CONTRACTS.FetchService)
            .post(`/contexts/${contextId}/stop`);
    }

    public async showLog() {
        this._windowsService!.open('log-page');
    }

    public async showUsers() {
        this._windowsService!.open('users-page');
    }

        public async showAudit() {
        this._windowsService!.open('audit-page');
    }

    public async uploadFile() {
        showFileUploader();
    }

    public async backup(): Promise<void> {
        const selectedBtn = await this._windowsService!.showDialog(
            'Backup database?',
            [{ id: 0, caption: 'Yes' }, { id: 1, caption: 'No' }]
        );
        if (selectedBtn === 0) {
            const fetchService = container.get<FetchServiceContract>(CONTRACTS.FetchService);
            const url = fetchService.buildAbsoluteUrl(
                `/management/backup-database`
            );

            try {
                await fetchService.post<string>(url);
            } finally {
                this._windowsService!.showDialog('Database backuped', [
                    {
                        id: 0,
                        caption: 'Ok'
                    }
                ]);
            }
        }
    }
}
